import React, { Component } from "react";
import classnames from "classnames";
import { times } from "lodash";
import { rand } from "../../utils/math";
import RunePad from "../RunePad";
import { Transition } from "react-spring";
import SkipModal from "../SkipModal";
import PropTypes from "prop-types";

function generateHintAnimationStyle(times, reversed, i) {
  return `RowDrift ${times[i]}s ease infinite${
    reversed[i] ? " alternate-reverse" : " alternate"
  }`;
}

class Challenge extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeHintIndex: undefined,
      isSolved: false,
      showingModal: false,
      shouldShow: window.__font_status === "loaded"
    };
    this.hintRowSpacerWidths = times(this.props.rowCount, _ =>
      Math.floor(Math.random() * 400)
    );
    this.hintRowReversed = times(this.props.rowCount, _ => Math.random() > 0.5);
    this.hintRowTimes = times(this.props.rowCount, _ => rand(300, 240));

    this.bottomBarRef = React.createRef();
    this.timeoutHandle = undefined;
    window.addEventListener(
      "font-loaded",
      _ => {
        this.startAnimation();
      },
      false
    );
  }
  shouldComponentUpdate(props, state) {
    return (
      this.props.shouldShowPad !== props.shouldShowPad || this.state !== state
    );
  }
  updateActiveHintIndex = () => {
    this.setState({
      activeHintIndex: rand(this.props.rowCount * this.props.columnCount) - 1,
      shouldShow: true
    });
  };
  startAnimation = () => {
    this.timeoutHandle = setInterval(this.updateActiveHintIndex, 2000);
    this.updateActiveHintIndex();
  };
  componentWillUnmount() {
    if (!this.timeoutHandle) return;
    clearInterval(this.timeoutHandle);
  }
  handleFoundRune = () => {
    this.setState({ isSolved: true });
  };
  render() {
    return !this.state.shouldShow ? null : (
      <div
        className={classnames(
          "hint-cover",
          this.props.useSingleHints && "hint-arrow"
        )}
        style={{ ...this.props.style }}
      >
        <Transition
          from={{ opacity: 0 }}
          enter={{ opacity: 1 }}
          leave={{ opacity: 0 }}
        >
          {this.props.shouldShowPad &&
            (styles => (
              <header
                className={classnames(this.state.isSolved && "solved")}
                style={styles}
              >
                <h1>{this.props.titleText}</h1>
                <RunePad
                  acceptedRunes={[this.props.acceptedRune]}
                  onFoundRune={this.handleFoundRune}
                />
                <button
                  onClick={this.props.onFoundRune.bind(
                    null,
                    this.props.acceptedRune
                  )}
                >
                  Continue
                </button>
              </header>
            ))}
        </Transition>
        {times(this.props.rowCount, i => {
          return (
            <div
              key={i}
              className="hint-row"
              style={
                this.state.shouldShow
                  ? {
                      animation: generateHintAnimationStyle(
                        this.hintRowTimes,
                        this.hintRowReversed,
                        i
                      )
                    }
                  : {}
              }
            >
              <div style={{ width: this.hintRowSpacerWidths[i] }} />
              {times(this.props.columnCount, j => {
                return (
                  <span
                    key={`${i}-${j}`}
                    style={
                      this.props.makeElementStyles &&
                      this.props.makeElementStyles(i, j)
                    }
                    className={classnames(
                      "hint",
                      i * this.props.rowCount + j ===
                        this.state.activeHintIndex && "active"
                    )}
                  >
                    {this.props.getHintElement
                      ? this.props.getHintElement(i, j)
                      : this.props.hintElement}
                  </span>
                );
              })}
            </div>
          );
        })}
        {this.props.shouldShowBypass && (
          <SkipModal onSkipPuzzles={this.props.onSkipPuzzles} />
        )}
      </div>
    );
  }
}

Challenge.propTypes = {
  rowCount: PropTypes.number,
  columnCount: PropTypes.number,
  makeElementStyles: PropTypes.func,
  acceptedRune: PropTypes.string,
  shouldShowBypass: PropTypes.bool,
  shouldShowPad: PropTypes.bool,
  onSkipPuzzles: PropTypes.func,
  onFoundRune: PropTypes.func
};

export default Challenge;



// WEBPACK FOOTER //
// ./src/components/challenges/Challenge.js